export default __webpack_public_path__ + "static/avatar-kayi-common-6-detail-ded56e53c7e9d90c3ade988f8d1a89f2.png";